var map = {
	"./aeration.png": "e50f",
	"./bed_weeding.png": "4fde",
	"./bushtrimming.png": "c34a",
	"./cleanup_leaves.png": "3666",
	"./cleanup_spring.png": "f078",
	"./fertilization.png": "0136",
	"./landscaping.png": "153d",
	"./mulching.png": "2dea",
	"./treecare.png": "68e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a1f";